export default __webpack_public_path__ + "static/media/partner-planet-mojo.9137273f.png";